import React, { PropsWithChildren, ReactNode, useCallback } from 'react';
import { Dialog, DialogActions, DialogContent, DialogProps } from '@mui/material';

import { DialogHeader } from './DialogHeader';

interface Props extends Omit<DialogProps, 'open' | 'onClose'> {
  label: string;
  isOpen: boolean;
  actions: ReactNode;
  onClose: VoidFunction;
  disableBackdropClose?: boolean;
}

export const CustomDialog = ({
  isOpen,
  onClose,
  actions,
  label,
  children,
  disableBackdropClose,
  ...dialogProps
}: PropsWithChildren<Props>) => {
  const handleClose = useCallback(
    (_event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
      if (disableBackdropClose && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return;
      onClose();
    },
    [disableBackdropClose, onClose]
  );

  return (
    <Dialog open={isOpen} maxWidth="sm" fullWidth onClose={handleClose} {...dialogProps}>
      <DialogHeader handleClose={onClose} label={label} />

      <DialogContent dividers>{children}</DialogContent>

      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
};
